export default __webpack_public_path__ + "static/media/flowgaming_logo.884dfe20.png";